module.exports = __webpack_public_path__ + "img/szwyIcon1.e98e7e32.jpg";